// extracted by mini-css-extract-plugin
module.exports = {"appFooter":"Footer_appFooter__K6tTk"};